import { apiRequest } from './apiClient';

const resolveDefaultApiBaseUrl = () => {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/api`;
  }
  return '/api';
};

const API_BASE_URL = process.env.REACT_APP_API_URL || resolveDefaultApiBaseUrl();
const TRADE_BASE_URL = process.env.REACT_APP_TRADE_API_URL || API_BASE_URL;

const buildUrlFromBase = (baseUrl, endpoint) => {
  if (!endpoint) return String(baseUrl || '');
  if (endpoint.startsWith('http://') || endpoint.startsWith('https://')) return endpoint;
  const base = String(baseUrl || '').replace(/\/$/, '');
  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${base}${path}`;
};

const buildTradeUrl = (endpoint) => buildUrlFromBase(TRADE_BASE_URL, endpoint);
const buildFallbackTradeUrl = (endpoint) => buildUrlFromBase(API_BASE_URL, endpoint);

export const tradeApiRequest = async (endpoint, options = {}) => {
  const primaryUrl = buildTradeUrl(endpoint);
  try {
    return await apiRequest(primaryUrl, options);
  } catch (error) {
    const primaryFailedByNetwork = String(error?.message || '').includes('Unable to reach server');
    if (!primaryFailedByNetwork) throw error;
    const fallbackUrl = buildFallbackTradeUrl(endpoint);
    if (!fallbackUrl || fallbackUrl === primaryUrl) throw error;
    return apiRequest(fallbackUrl, options);
  }
};

export const tradeApiGet = (endpoint, options = {}) =>
  tradeApiRequest(endpoint, { ...options, method: 'GET' });

/** Broker positions/holdings/orders — always bypass short-lived GET memo (live portfolio data). */
export const tradeApiGetLive = (endpoint, options = {}) =>
  tradeApiRequest(endpoint, { ...options, method: 'GET', skipCache: true });

export const tradeApiPost = (endpoint, body, options = {}) =>
  tradeApiRequest(endpoint, {
    ...options,
    method: 'POST',
    body: body ? JSON.stringify(body) : undefined,
  });
